module.exports = __webpack_public_path__ + "img/creator1.1267211.png";